import { useSelector } from 'react-redux';
import { gql, useMutation } from '@apollo/client';

const useUpdateSchedule = () => {
  const { userId } = useSelector(mapStateToProps);

  const [__updateSchedule] = useMutation(MUTATION, {
    refetchQueries: [
      'scheduledDeployment'
    ]
  });
  const updateSchedule = (versionId, deployAt, rebuildRequired, scheduleId) => __updateSchedule({
    variables: {
      versionId,
      deployAt,
      userId,
      rebuildRequired,
      status: 'SCHEDULED',
      scheduleId
    }
  });

  return {
    updateSchedule
  };
};

const MUTATION = gql`
mutation updateSchedule($versionId: String!, $deployAt: Float, $userId: String!, $rebuildRequired: Boolean, $scheduleId: String!) {
  updateSchedule(versionId: $versionId, deployAt: $deployAt, userId: $userId, rebuildRequired: $rebuildRequired, scheduleId: $scheduleId) {
    _id
    deployAt
    version
    bucketName
    state
  }
}
`;

/* =============================================================================
=    Redux
============================================================================= */
const mapStateToProps = state => ({
  userId: state.app.user && state.app.user._id
});

export default useUpdateSchedule;
